'use client'

import {useReportWebVitals} from 'next/web-vitals'

/**
 * Reports Core Web Vitals — LCP, CLS, INP (real-user interaction-to-next-paint),
 * FCP, TTFB — to the browser console in development, and to an analytics
 * endpoint in production.
 *
 * INP specifically is a RUM-only metric: it measures real user interaction
 * latency and only fires when a user actually clicks/types. It will not
 * appear in Lighthouse lab runs. This reporter exposes INP to the dev
 * console for spot-checks and is the wiring point for sending the metric
 * to an analytics endpoint when one is configured.
 */
export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[web-vitals] ${metric.name}: ${metric.value.toFixed(2)}`, {
        id: metric.id,
        rating: metric.rating,
      })
      return
    }

    // Production: send a beacon if an endpoint is configured.
    const endpoint = process.env.NEXT_PUBLIC_WEB_VITALS_ENDPOINT
    if (!endpoint) return
    try {
      const body = JSON.stringify({
        name: metric.name,
        value: metric.value,
        id: metric.id,
        rating: metric.rating,
        path: window.location.pathname,
      })
      if (typeof navigator.sendBeacon === 'function') {
        navigator.sendBeacon(endpoint, body)
      } else {
        fetch(endpoint, {body, method: 'POST', keepalive: true})
      }
    } catch {
      // Swallow — telemetry must not break the page
    }
  })

  return null
}
